import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { API_BASE as API } from '../utils/apiBase';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    const verify = async () => {
      try {
        const response = await axios.get(`${API}/api/auth/verify-email?token=${token}`, { withCredentials: true });
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully!');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Verification failed. The link may have expired.');
      }
    };
    verify();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="max-w-md w-full bg-white p-8 text-center">
        {status === 'verifying' && (
          <>
            <Loader2 size={48} className="animate-spin text-[#002fa7] mx-auto mb-4" />
            <h1 className="font-satoshi text-2xl font-bold text-[#0f1115] mb-2">Verifying your email...</h1>
            <p className="text-[#6b7280]">Please wait a moment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={48} className="text-[#10b981] mx-auto mb-4" />
            <h1 className="font-satoshi text-2xl font-bold text-[#0f1115] mb-2">Email Verified!</h1>
            <p className="text-[#6b7280] mb-6">{message}</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="px-6 py-3 bg-[#002fa7] text-white font-semibold hover:bg-[#001d6a] transition-colors"
              data-testid="go-to-dashboard-btn"
            >
              Go to Dashboard
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={48} className="text-[#e11d48] mx-auto mb-4" />
            <h1 className="font-satoshi text-2xl font-bold text-[#0f1115] mb-2">Verification Failed</h1>
            <p className="text-[#6b7280] mb-6">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="px-6 py-3 bg-[#002fa7] text-white font-semibold hover:bg-[#001d6a] transition-colors"
              data-testid="go-to-login-btn"
            >
              Go to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
